import addWindowOnBeforeUnloadCallback from "./addWindowOnBeforeUnloadCallback";
import createFilteredItemsInstance from "./createFilteredItemsInstance";
import createFormInstance from "./createFormInstance";
import createResourceInstance from "./createResourceInstance";

export { addWindowOnBeforeUnloadCallback, createFilteredItemsInstance, createFormInstance, createResourceInstance };



// WEBPACK FOOTER //
// ./src/modules/utils/index.js